// extracted by mini-css-extract-plugin
export default {"Link":"ServiceLink_Link__8cf05","Title":"ServiceLink_Title__rQA4E","Intro":"ServiceLink_Intro__uZFAy"};